module.exports = __webpack_public_path__ + "img/2023_ohio_1.384579af.jpg";